module.exports = __webpack_public_path__ + "img/icone-de-email.c398ddba.png";